import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import {Box, IconButton, Tooltip, Typography} from '@mui/material';
import {ReactNode, useRef} from 'react';
import ChartExportMenu, {EXPORT_IGNORE} from '../../Fsv/components/ChartExportMenu';

interface ChartCardProps {
    code: string;
    title: string;
    tooltip: string;
    unit: string;
    n?: {project: number; bando: number};
    note?: string;
    children: ReactNode;
}

const ChartCard = ({code, title, tooltip, unit, n, note, children}: ChartCardProps) => {
    const cardRef = useRef<HTMLDivElement>(null);

    return (
        <Box
            ref={cardRef}
            sx={{border: '1px solid', borderColor: 'divider', borderRadius: 2.5, p: 2, bgcolor: 'background.paper', display: 'flex', flexDirection: 'column'}}
        >
            <Box sx={{display: 'flex', alignItems: 'flex-start', gap: 0.75, mb: 1}}>
                <Typography variant='caption' sx={{color: 'primary.main', fontWeight: 600, pt: '2px', flexShrink: 0}}>
                    {code}
                </Typography>
                <Typography variant='body2' component='h3' sx={{flex: 1, lineHeight: 1.45, fontWeight: 500}}>
                    {title}
                </Typography>
                <Tooltip title={tooltip} placement='top' arrow>
                    <IconButton {...EXPORT_IGNORE} size='small' aria-label='Come leggere il grafico' sx={{p: '2px', color: 'text.secondary', flexShrink: 0}}>
                        <InfoOutlinedIcon sx={{fontSize: 16}} />
                    </IconButton>
                </Tooltip>
                <ChartExportMenu target={cardRef} title={`${code} ${title}`} />
            </Box>
            <Box sx={{flex: 1}}>{children}</Box>
            {n && n.project === 0 && (
                <Typography variant='caption' color='text.secondary' sx={{mt: 1, fontStyle: 'italic'}}>
                    Il progetto non ha ancora dati sufficienti per questo grafico.
                </Typography>
            )}
            <Typography variant='caption' color='text.secondary' sx={{mt: 0.5}}>
                {n ? `Calcolato su ${n.project} ${unit} del progetto e ${n.bando} ${unit} del bando.` : note}
            </Typography>
        </Box>
    );
};

export default ChartCard;
